
import { BaseModel } from "./base/base.model";

export class AppA3DocConnection extends BaseModel {
  a3docConnection1?: string;
  tenant?: string;
  user?: string;
  password?: string;
  deviceId?: string;
  deviceType?: Number;
  devicePlatform?: Number;
  apiKey?: string;
  environment?: string;
  modifiedOn?: string;
  createdAt?: string;
}
